import React from "react";
import "../../CSS/Industries.css";

function Education() {
    return (
        <>

            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">
                    <div className="industry-detail-hero-content">

                        <h1>Solutions for Education</h1>
                        <p style={{ color: '#FF7D37' }}>
                            We help educational institutions improve learning,
                            administration, communication, and digital operations
                            with practical technology solutions.
                        </p>
                    </div>
                </div>
            </section>


            <section className="industry-detail-section">
                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">

                            <h2>
                                Digital Solutions for Modern Education
                            </h2>

                            <p>
                                Educational organizations need reliable systems
                                to manage students, staff, courses, communication,
                                and day-to-day operations.
                            </p>

                            <p>
                                We develop websites, web applications, management
                                systems, and custom software designed around the
                                requirements of educational organizations.
                            </p>
                        </div>

                        <div className="col-lg-6">
                            <img
                                src="/images/home/education.png"
                                alt="Education Technology Solutions"
                                className="industry-detail-image"
                            />
                        </div>

                    </div>

                </div>
            </section>


            <section className="industry-features">
                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Educational Organizations</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-mortarboard"></i>
                            <h3>Student Management</h3>
                            <p>Systems to manage student information and academic processes.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-globe"></i>
                            <h3>Education Websites</h3>
                            <p>Professional websites for schools, colleges, institutes, and training organizations.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-bar-chart"></i>
                            <h3>Reports & Analytics</h3>
                            <p>Useful reports and dashboards for better decision making.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-chat-dots"></i>
                            <h3>Communication</h3>
                            <p>Digital communication solutions for students, staff, and management.</p>
                        </div>

                    </div>
                </div>
            </section>

        </>
    );
}

export default Education;